export const RECEIVE_REGISTRY_COLLECTION = 'zola/blender/RECEIVE_REGISTRY_COLLECTION';
export const REMOVE_TOP_CARD = 'zola/blender/REMOVE_TOP_CARD';
export const CARD_PASSED_OR_ADDED = 'zola/blender/CARD_PASSED_OR_ADDED';
export const RESET_BLENDER = 'zola/blender/RESET_BLENDER';
